import { gql } from '@apollo/client';
const REMOVE_WAREHOUSE_RELEASE_MODEL = gql `
  mutation RemoveWarehouseReleaseModel($warehouseReleaseModelId: String!) {
    removeWarehouseReleaseModel(warehouseReleaseModelId: $warehouseReleaseModelId) {
      removed
    }
  }
`;
export default REMOVE_WAREHOUSE_RELEASE_MODEL;
